/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { colors } from '../../../theme';

export const PageDashboardContainerStyled = styled.div.attrs({
    className: 'dashboard-page',
})`
    flex: 1 0 auto;
    background-color: ${colors.pageDashboardContainerBgColor};
`;
